export interface StartImportPatentsRequest {
    task_id: string;
    /**
     * 文件夹ID，没填则为检查task下是否有正在进行中的导入任务
     */
    folder_id?: string;
    /**
     * 批量大小
     */
    batch_size?: number;
}

export interface StartImportPatentsResponse {
    async_id: string;
    status: 'PROCESSING' | 'COMPLETED' | 'FAILED';
    total_patents: number;
    estimated_minutes: number;
    batch_size: number;
}

export interface GetImportProgressRequest {
    async_id: string;
}

export interface GetImportProgressResponse {
    async_id: string;
    status: 'PROCESSING' | 'COMPLETED' | 'FAILED';
    processed_patents: number;
    completed_patents: number;
    failed_patents: number;
    progress: number;
    failed_patent_ids: string[];
    new_completed_patent_ids: string[];
    new_results: any[];
    estimated_remaining_minutes: number;
    current_timestamp: number;
}

export const FtoReportImportPatentsApi = Symbol.for('FtoReportImportPatentsApi');

export interface FtoReportImportPatentsApi {
    startImportPatents(request: StartImportPatentsRequest, signal?: AbortSignal): Promise<StartImportPatentsResponse>;
    getImportProgress(request: GetImportProgressRequest, signal?: AbortSignal): Promise<GetImportProgressResponse>;
}
